import type { AgentsSettings, ToolId, ToolJob, ToolsOverview, UpdatesInfo, UpdateState } from "@codvero/shared";
import { api, get, post } from "./client.ts";

export const settingsApi = {
  agents: () => get<AgentsSettings>("/api/settings/agents"),
  setAgents: (v: AgentsSettings) => api<AgentsSettings>("/api/settings/agents", { method: "PUT", json: v }),
  updates: () => get<UpdatesInfo>("/api/system/updates"),
  checkUpdates: () => post<UpdatesInfo>("/api/system/updates/check"),
  runUpdate: (tag?: string) => api<UpdateState>("/api/system/updates/run", { method: "POST", json: tag ? { tag } : {} }),
  updateStatus: () => get<{ state: UpdateState | null; running: { commit: string | null; startedAt: string | null; version: string } }>("/api/system/updates/status"),
  setUpdatesToken: (token: string | null) => api<UpdatesInfo>("/api/system/updates/token", { method: "PUT", json: { token } }),
  tools: () => get<ToolsOverview>("/api/system/tools"),
  toolsCheck: () => post<ToolsOverview>("/api/system/tools/check"),
  toolUpdate: (id: ToolId, version?: string) => api<ToolJob>(`/api/system/tools/${id}/update`, { method: "POST", json: version ? { version } : {} }),
  toolRollback: (id: ToolId) => post<ToolJob>(`/api/system/tools/${id}/rollback`),
};
